import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { V2ProductTreeService } from "../../services/api/v2-product-tree.service";
import { ProductTreeActions } from "../actions/product-tree.actions";
import { FailState } from "../models/fail-state";
import { ProductTreeState } from "../models/mp-common/product-tree.state";
import { AppState } from "../reducers";
import { ProductTreeSelectors } from "../selectors/product-tree.selectors";

@Injectable()
export class ProductTreeEffects {
	productTree = createEffect(() =>
		this.actions.pipe(
			ofType(ProductTreeActions.productTree.get),
			withLatestFrom(this.store.select(ProductTreeSelectors.productTree)),
			switchMap(([, state]) =>
				this.canUseStoreValue(state)
					? of(ProductTreeActions.productTree.success({ state }))
					: of(ProductTreeActions.productTree.api())
			)
		)
	);

	productTreeApi = createEffect(() =>
		this.actions.pipe(
			ofType(ProductTreeActions.productTree.api),
			switchMap(() =>
				this.productTreeService.getProductTree().pipe(
					map((tree) =>
						ProductTreeActions.productTree.success({
							state: { tree, loading: false }
						})
					),
					catchError((error) =>
						of(ProductTreeActions.productTree.fail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private productTreeService: V2ProductTreeService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(state: ProductTreeState): boolean {
		return (
			state !== undefined &&
			!_.has(state, "error") &&
			!state.loading &&
			_.has(state, "tree")
		);
	}
}
